export default __webpack_public_path__ + "static/media/bg1 (3).1a9c9b86.svg";